const swiperReview = new Swiper('.review-slider__contents', {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 20,
  pagination: {
      el: '.review-slider__contents .swiper-pagination-col',
      clickable: true,
  },
  breakpoints: {
    580: {
      slidesPerView: 2,
    },
    980: {
      slidesPerView: 4,
    }
  }
});